import {
  FETCH_BUSS_SUCCESS,
  FETCH_BUSS_ERROR,
  FETCH_BUSS,
  CLEAR_BUSSES,
} from './constants';

const poolingInitialState = {
  isFetching: false,
  seatsById: null,
};

const seatingsReducer = (state = poolingInitialState, action) => {
  switch (action.type) {
    case FETCH_BUSS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        seatsById: {
          ...state.seatsById,
          [action.idBuss]: { ...action.payload.seats }
        }
      };
    case FETCH_BUSS_ERROR:
      return {
        ...state,
        isFetching: false,
        seatsById: {
          ...state.seatsById,
          [action.idBuss]: action.payload
        }
      };
    case FETCH_BUSS:
      return {
        ...state,
        isFetching: true,
      };
    case CLEAR_BUSSES:
      return {
        ...state,
        seatsById: {}
      }
    default:
      return state;
  }
};

export default seatingsReducer;



// WEBPACK FOOTER //
// ./src/components/Bus/reducer.js